module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/life_coop_2-9a8125f3444619d4bef9e4e8b866db88.png";